import angular from 'angular';
import { createError } from '../error';

class GlobalMessageService {
  constructor() {
    this._messages = [];
  }

  get messages() {
    return this._messages;
  }

  addMessage(msg) {
    if (msg.message === undefined) {
      msg = {message: msg};
    }
    this.messages.push(msg);
  }

  addError(err) {
    if (err.error === undefined) {
      err = createError({message: err, error: 'Unknonwn'});
    }
    this.messages.push(err);
  }

  clearMessageIndex(idx) {
    this._messages.splice(idx, 1);
  }

  clearMessages() {
    this._messages = [];
  }
}

let module = angular.module('recaps.services.GlobalMessageService', []);
module.service('GlobalMessageService', GlobalMessageService);

export default module;
